import React, { useId } from "react";
import { SwiperOptions } from "swiper";
import { Swiper as SwiperReact } from "swiper/react";

import { clsx } from "clsx";

export const generateSlideCssForBreakpoints = ({
  id,
  slidesPerView,
  spaceBetween,
  breakpoints,
  direction,
}: SwiperOptions) => {
  const defaultCss = `
    #${id} .swiper-slide {
      width: ${100 / slidesPerView}%;
      margin-right: ${spaceBetween}px;
    }
  `;

  const spaceToReduce = (slidesPerView - 1 * spaceBetween - 1) / slidesPerView;

  const breakpointCss = breakpoints
    ? Object.keys(breakpoints).map((key) => {
        const breakpoint = breakpoints[key];
        const { slidesPerView, spaceBetween } = breakpoint || {};
        const width = isNaN(slidesPerView) ? 100 : 100 / slidesPerView;
        const margin = spaceBetween + spaceToReduce;

        return `
          @media only screen and (min-width: ${key}px) {
            #${id} .swiper-slide {
              width: calc(${width}% - ${margin}px);
              ${["horizontal", undefined].includes(direction) ? `margin-right: ${spaceBetween}px` : `margin-bottom: ${spaceBetween}px`};
            }
          }
        `;
      })
    : [];

  return [defaultCss, ...breakpointCss].join("\n");
};

const Container = (props: any) => (
  <>
    <div
      {...props}
      className={clsx(props.className, "swiper-component w-full")}
    />
    <style>
      {generateSlideCssForBreakpoints({
        id: props.id,
        slidesPerView: props.slidesPerView,
        spaceBetween: props.spaceBetween,
        breakpoints: props.breakpoints,
        direction: props.direction,
      })}
    </style>
  </>
);

const SwiperWrapper = (props: SwiperOptions) => {
  const id = useId();

  return (
    <Container {...props} id={id}>
      <SwiperReact {...props} />
    </Container>
  );
};

export default SwiperWrapper;
